// extracted by mini-css-extract-plugin
export default {"barcodeScanner":"BarcodeScanner-module__barcodeScanner--U4jB","video":"BarcodeScanner-module__video--WGbq"};